import {inject, Injectable} from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, CanActivateFn} from '@angular/router';
import { Router } from '@angular/router';
import {JwtHelperService} from "@auth0/angular-jwt";
import { profileStore } from '@core/store';
import {SecurityService} from "@core/services";

@Injectable({
  providedIn: 'root'
})
class PermissionsService {
    private store = inject(profileStore);

  constructor(private router: Router,
              private jwtHelper: JwtHelperService,
              private securityService: SecurityService) {}



  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token  = this.store.data.token.value();
    if (!token) {
      this.noValidToken();
      return  false;
    }

    if (!this.jwtHelper.isTokenExpired(token)) {
      return true;
    } else {
      this.noValidToken();
      return false;
    }

  }

    noValidToken():void{
    this.securityService.logout();
  }
}

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(PermissionsService).canActivate(next, state);
}